import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {AppBar, Toolbar, Typography, IconButton, Button, Box, Divider, Grid} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import logo from '../assets/img/logo.svg';
import Notification from "./ActionTab/Notification";
import Profile from "./ActionTab/Profile";
// import Messages from "./ActionTab/Messages";
import { useStateValue } from "../contexto/store";


const useStyles = makeStyles(theme => ({
    menuButton: {
        color: 'black',
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    title:{
        flexGrow: 1,
        marginTop: '0px'
    },
    appBar: {
        backgroundColor: 'white',
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${240}px)`,
            marginLeft: 240,
        },
    },
    link: {
        textDecoration: 'none',
        color: 'white'
        
    },
    imagen:{
        width: '370px',
        height: '50px',
        marginTop: '20px',
        marginLeft:'30px'
    },
    menulink: {
        borderRight: 'solid white 0.3px'
    },
    divider: {
        orientation: 'horizontal'
    }
}));

// function getMenuUsuario()

const Navbar = (props) => {
    const classes = useStyles();
    const [{sesionUsuario}, dispatch] = useStateValue();
    return (
        <AppBar className={classes.appBar}>
            <Toolbar>
                <IconButton 
                    color="inherit" 
                    aria-label="menu" 
                    className={classes.menuButton}
                    onClick={() => props.accionAbrir()}
                >
                    <MenuIcon />
                </IconButton>
               
                <Typography variant='h6' className={classes.title}>
                       <img src={logo} className={classes.imagen}/>
                </Typography>
                {/* llamada a variable global para la sesion de usuario */}
                <Button>
                    {sesionUsuario ? sesionUsuario.usuario.correo: ""}
                </Button>
                <Box container="true"> 
                    <Grid container alignItems="center">
                        <Profile />
                            <Divider orientation="vertical" flexItem />
                        <Notification/>
                        {/* <Messages /> */}
                    </Grid>
                </Box>
            </Toolbar>
        </AppBar> 
    )
}

export default Navbar;
